import { render, staticRenderFns } from "./ItemListCollectionLayout.vue?vue&type=template&id=ffbb0b06&scoped=true&"
import script from "./ItemListCollectionLayout.vue?vue&type=script&lang=js&"
export * from "./ItemListCollectionLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbb0b06",
  null
  
)

export default component.exports